@import '../../../theme.scss';

verdocs-field-dropdown {
  font-family: $verdocs-primary-font;
  width: 85px;
  height: 20px;
  display: block;
  font-size: 11px;
  position: relative;
  scroll-margin: 20px 0;
  background-color: var(--verdocs-field-background, transparent);
  transform-origin: bottom left;
  border-radius: var(--verdocs-field-radius);

  label {
    top: -14px;
    left: 0;
    height: 14px;
    color: white;
    padding: 0 4px;
    font-size: 9px;
    line-height: 13px;
    position: absolute;
    background: #4a4a99;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  select {
    // This is needed to bring down the cursor from the parent element, which is where interactjs applies it
    cursor: inherit;

    position: absolute;
    background:
      linear-gradient(55deg, transparent 50%, var(--verdocs-field-text-color, #333) 50%), linear-gradient(125deg, var(--verdocs-field-text-color, #333) 50%, transparent 50%),
      linear-gradient(to right, transparent, transparent);
    background-position:
      calc(100% - 7px) 6px,
      calc(100% - 3px) 6px,
      100% 0;
    background-size:
      5px 5px,
      5px 5px,
      2.5em 2.5em;
    background-repeat: no-repeat;
    appearance: none;

    box-sizing: border-box;
    color: var(--verdocs-field-text-color, rgba(0, 0, 0, 0.87));
    font-weight: 500;
    transform-origin: 0 0;
    height: 100%;
    width: 100%;
    font-size: 11px;
    border: var(--verdocs-field-border, 1px solid rgba(0, 0, 0, 0.2));
    border-radius: var(--verdocs-field-radius);
    padding: 0 5px;

    &:focus {
      outline: none;
    }

    &.hide {
      display: none;
    }
  }

  &.disabled select {
    opacity: 0.5;
  }

  &.required {
    select {
      border: 1px solid var(--verdocs-required-field-border);
    }
  }

  verdocs-button-panel {
    display: block;
    margin-left: -33px;
    margin-top: -1px;
    transform: scale(0.7);
  }

  .settings-icon {
    position: absolute;
    top: -2px;
    left: -20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.3;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }
}
